import styled from 'styled-components';

export const Requirements = styled.div`
  font-size: 1rem;
  font-family: DM Sans Regular, sans-serif;
  line-height: 1.5;
  color: #0b1f1c;
  -webkit-font-smoothing: antialiased;
  margin-top: 8px;
  opacity: 80%;
`;

export const MonthContainer = styled.div``;
